$(function() {

$(".workshop-slider").slick({
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [
    {
        breakpoint: 576,
        settings: {
        slidesToShow: 3,
        centerPadding: false,
        }
    }
  ]
});
        
        });